import { Component, Input, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'slnk-shared-input-validator',
  templateUrl: './shared-input-validator.component.html',
  styleUrls: ['./shared-input-validator.component.scss']
})
export class SharedInputValidatorComponent implements OnInit {

  @Input() validationFormControl: FormControl;

  constructor() {
  }

  ngOnInit() {
  }

}
